import React, { useState } from "react";
import { Link } from "react-router-dom";
import googleicon from '../../../assets/images/google-icon.png'
import facebookicon from '../../../assets/images/facebook-icon.png'
import toastify from "../../../helper/toastify";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/features/auth/authSliceNew";
import LoginOtp from "./LoginOtp";

export default function SignUp() {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [otpPhone, setOtpPhone] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!phone) {
      toastify.error("Please enter your mobile number");
      return;
    }
    setLoading(true)
    try {
      const response = await dispatch(login({ mobile: phone }));
      if (response.success) {
        setOtpPhone(phone);
        // const registerModalEl = document.getElementById('signup-modal');
        // const registerInstance = window.bootstrap.Modal.getInstance(registerModalEl)
        // registerInstance.hide();
        document.querySelector('[data-bs-dismiss="modal"]').click();
        const verifyModal = new window.bootstrap.Modal(document.getElementById('otp-modal'));
        verifyModal.show();
      }
    } catch (error) {
    } finally {
      setLoading(false)
    }

  };
  // const dispatch = useDispatch();
  // let [mobile, setMobile] = useState("");
  // const [searchParams, setSearchParams] = useSearchParams();

  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   if (mobile.length < 10) {
  //     return toastify.error("The mobile field must be 10 digits.");
  //   }
  //   dispatch(loadingStart());
  //   try {
  //     let res = await axiosInstance.post(`${baseUrl}/register`, {
  //       mobile: mobile,
  //     });
  //     dispatch(loadingStop());
  //     if (res.data.status_code == "200") {
  //       toastify.success(res.data.message);
  //       dispatch(addNumber({ mobile: mobile }));
  //       setSearchParams((prev) => {
  //         prev.set("mobile", mobile);
  //         return prev;
  //       })
  //       setMobile("")
  //       let closeLoginModel = document.getElementById("closeLoginModel")
  //       closeLoginModel?.click()
  //     } else {
  //       toastify.error(res.data.message);
  //     }
  //   } catch (error) {
  //     dispatch(loadingStop());
  //   }
  // };
  return (
    <>
      <div
        className="modal fade login-modal" id="signup-modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="exampleModalLabel">
                Sign up
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <form action="" onSubmit={handleSubmit}>
                <div className="custom-frm-bx">
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    placeholder="Mobile Number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <div className="custom-frm-bx">
                  <button className="thm-btn fill-btn w-100" type="submit" disabled={loading} >
                    {loading ? 'Continuing...' : 'Continue'}
                  </button>
                </div>
              </form>
              <p className="line text-center">
                <span>OR</span>
              </p>
              <div className="login-btn">
                <Link to="" className="w-100 text-center">
                  <img src={googleicon} className="me-2" alt="" />
                  Sign in with Google
                </Link>
                <Link to="" className="w-100 text-center">
                  <img src={facebookicon} className="me-2" alt="" />
                  Continue with Facebook
                </Link>
              </div>
              <p className="text-center nw-account">
                Already have an account?{" "}
                <Link
                  to=""
                  data-bs-toggle="modal"
                  data-bs-target="#login-modal"
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <LoginOtp phone={otpPhone} />
    </>
  );
}
